export enum BurgerMenuTabNames {
  ProductsTab = 'products-tab',
  AccountTab = 'account-tab',
}
